<mat-sidenav-container
  #sidenavContainer
  class="sidebar-container"
  autosize
  (keydown.escape)="isHandset ? (opened = false) : (hidden = true)"
>
  <!-- SIDENAV  -->
  <mat-sidenav
    #sidenav
    position="end"
    class="sidebar-sidenav sidenav-fixed"
    [mode]="sidenavMode"
    [opened]="
      isHandset
        ? (mapaService.sidenavOpened$ | async)
        : !(mapaService.sidenavHidden$ | async)
    "
    [style.width]="isHandset ? '100%' : sidebarWidth + 'px'"
    [style.min-width.px]="isHandset ? 0 : minSidebarWidth"
    [style.max-width]="isHandset ? '100%' : 'none'"
    (backdropClick)="onBackdropClick()"
  >
    <!-- Manija para cambiar el ancho (el panel está a la derecha: va en su borde izquierdo) -->
    @if (!isHandset) {
      <div
        class="resize-handle-sidebar irx-clickeable"
        role="separator"
        aria-orientation="vertical"
        tabindex="-1"
        title="Arrastrar para cambiar el ancho"
        (mousedown)="startResizeSidebar($event)"
      ></div>
    }

    <!-- BARRA LATERAL -->
    <app-barra-lateral
      [mapasPersonalizados]="mapaIndividual?.mapasPersonalizados"
      [tipoMapaBaseKey]="'tipoMapaBaseVehiculosComponent'"
      (reporteChange)="onReporteChange($event)"
      (tipoMapaBaseChange)="onTipoMapaBaseChange($event)"
      (toggleHelpChange)="onToggleHelp()"
      (busquedaVehiculos)="onBusquedaVehiculos($event)"
    ></app-barra-lateral>
  </mat-sidenav>

  <!-- CONTENIDO PRINCIPAL (mapa) -->
  <mat-sidenav-content>
    <div
      class="contenedor-mapa"
      style="
        display: grid;
        width: 100%;
        height: 100%;
        grid-template-columns: 100%;
        gap: 1%;
      "
    >
      <!-- Columna izquierda: MAPA Y FLOTANTES -->
      <div
        class="columna-izquierda"
        style="position: relative; width: 100%; height: 100%"
      >
        <!-- Botón flotante para controlar sidebar, visible siempre -->
        <button
          irxBotonIcono="mapa"
          class="toggle-sidebar-button"
          aria-label="Abrir/Cerrar panel derecho"
          (click)="toggleSidenav()"
         tooltip="Abrir/Cerrar panel derecho">
          <mat-icon>
            {{
              isHandset
                ? opened
                  ? 'close'
                  : 'menu'
                : hidden
                  ? 'menu_open'
                  : 'menu'
            }}
          </mat-icon>
        </button>

        <!-- MAPAS INDIVIDUALES -->
        @if (
          !(mapaService.loadingMapa$ | async) && (mapaService.reportes$ | async)
        ) {
          <app-mapa-individual-vehiculos
            #mapaIndividual
            style="width: 100%; height: 100%"
            [reportes]="mapaService.reportes$ | async"
            [cantMapas]="mapaService.cantMapas$ | async"
            [mapaSeleccionado]="mapaSeleccionado"
            (mapaSeleccionadoChange)="onMapaSeleccionadoChange($event)"
            (reporteSeleccionadoVer)="reporteSeleccionadoChange($event)"
            (ubicacionSeleccionadaVer)="ubicacionSeleccionadaChange($event)"
            [seleccionadoBarraLateral]="seleccionadoBarraLateral"
            (paradaSelectedOut)="mapaService.setParadaSeleccionada($event)"
            (eventoSelectedOut)="mapaService.setEventoSeleccionado($event)"
            (circuloBusquedaChange)="mapaService.setCirculoBusqueda($event)"
            [ubicaciones]="mapaService.ubicaciones$ | async"
            [recorridos]="mapaService.recorridos$ | async"
            [recorridosDinamicos]="mapaService.recorridosDinamicos$ | async"
            [seleccionadosGenerales]="
              mapaService.seleccionadosBarraLateral$ | async
            "
          ></app-mapa-individual-vehiculos>
        }
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
